<template>
    <b-navbar v-if="user" toggleable="lg" :variant="getLayoutNavbarBg()"
              class="layout-navbar align-items-lg-center container-p-x">
        <!-- Brand demo (see demo.css) -->
        <b-navbar-brand to="/">
            <span class="app-brand-logo">
                <img style="height:30px;" :src="require('@/assets/logo_opengraph.png')"/>
            </span>
        </b-navbar-brand>
        <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>
        <b-collapse is-nav id="app-layout-navbar">
            <b-navbar-nav class="align-items-lg-center ml-auto" style="z-index:150; positon:fixed">
                <b-nav-item>
                    <router-link to="/" @click.native="logout()">{{ $t('logout')}}</router-link>
                </b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>
<style>
    .b-navbar {
        z-index: 200;
    }
</style>
<script>
    import {mapState} from 'vuex';
    import {AUTH_LOGOUT} from '../_store/authenticate/actiontypes';
    import {SWITCH_LANGUAGE_REQUEST} from "../_store/translation/actiontypes";

    export default {

        name: 'app-layout-navbar',

        props: {
            sidenavToggle: {
                type: Boolean,
                default: true
            }
        },
        computed: mapState({user: state => state.user.user}),
        mounted() {
            if (this.$cookie.get('language') === 'fr' || this.$cookie.get('language') === 'en') {
                this.$i18n.locale = this.$cookie.get('language')
            } else {
                this.$cookie.set('language', 'fr', 300);
                location.reload();
            }

        },
        methods: {
            changeLanguage(language) {
                this.$cookie.set('language', language, 300);
                location.reload();
            },
            logout() {
                this.$store.dispatch(AUTH_LOGOUT)
                    .then(response => {
                        this.$router.push('/');
                    })
            },
            toggleSidenav() {
                this.layoutHelpers.toggleCollapsed()
            },

            getLayoutNavbarBg() {
                return this.layoutNavbarBg
            },
            returnLanguageCookie() {
                return this.$cookie.get('language');
            }
        }
    }
</script>
